/**
 * Pagina encargada de gestionar mi perfil
 * @author sebastian rojas <sebastian.rojas@repremundo.com.co>
 */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Divider, Heading, Stack, StackRow } from "codekit";
import Comunicx from "../components/Comunicx";
import Devicesx from "../components/Devicesx";
import Chanpass from "../components/Chanpass";
import { getIsReplaceUser } from "../libs/redux/slices/authSlice/authSlice";
import Informat from "../components/Informat";
import Myprefex from "../components/Myprefex";
import Adminxxx from "../components/Adminxxx";
import { getIsAdmin } from "../libs/redux/slices/authSlice/authSlice";

const MyProfile = ({ handleClickHome }) => {
  const [tabs, setTabs] = useState("MYPREFERENCES");
  const isReplaceUser = useSelector(getIsReplaceUser);
  const isAdmin = useSelector(getIsAdmin);
  const [validateAdmin, setValidateAdmin] = useState(isAdmin);

  useEffect(() => {
    setValidateAdmin(isAdmin);
  }, [isAdmin]);

  /**
   * funcion encargada de gestionar que debe pintar acorde a la seleccion del tab
   * @returns componente a pintar
   */
  const onSelectTab = () => {
    switch (tabs) {
      case "COMMUNICATIONS":
        return <Comunicx />;
      case "DEVICES":
        return <Devicesx />;
      case "INFORMATION":
        return <Informat />;
      case "CHANGEPASSWORD":
        return <Chanpass />;
      case "MYPREFERENCES":
        return <Myprefex />;
      case "ADMINXXX":
        return <Adminxxx handleClickHome={handleClickHome} />;
      default:
        return "";
    }
  };

  return (
    <>
      <Box spacingX={6}>
        <Box mt={6} mb={6}>
          <Heading variant="heading-4" color="accent-600">
            Mi Perfil
          </Heading>
        </Box>
        <Divider />
        <Box mt={3} mb={3}>
          <Stack gap={8}>
            <StackRow>
              <Stack
                responsiveColumns={{
                  initial: 1,
                  small: 1,
                  large: validateAdmin ? 6 : 5,
                  extraLarge: validateAdmin ? 6 : 5,
                }}
                gap={1}
              >
                <StackRow>
                  <Button
                    variant={tabs === "MYPREFERENCES" ? "terciary" : "secondary"}
                    type="button"
                    size="m"
                    isFull
                    onClick={() => setTabs("MYPREFERENCES")}
                    inactive={isReplaceUser}
                  >
                    Mis Preferencias
                  </Button>
                </StackRow>
                <StackRow>
                  <Button
                    variant={tabs === "INFORMATION" ? "terciary" : "secondary"}
                    type="button"
                    size="m"
                    isFull
                    onClick={() => setTabs("INFORMATION")}
                    inactive={isReplaceUser}
                  >
                    Información Personal
                  </Button>
                </StackRow>
                <StackRow>
                  <Button
                    variant={tabs === "CHANGEPASSWORD" ? "terciary" : "secondary"}
                    type="button"
                    size="m"
                    isFull
                    onClick={() => setTabs("CHANGEPASSWORD")}
                    inactive={isReplaceUser}
                  >
                    Cambiar Contraseña
                  </Button>
                </StackRow>
                <StackRow>
                  <Button
                    variant={tabs === "COMMUNICATIONS" ? "terciary" : "secondary"}
                    type="button"
                    size="m"
                    isFull
                    onClick={() => setTabs("COMMUNICATIONS")}
                  >
                    Comunicaciones
                  </Button>
                </StackRow>
                <StackRow>
                  <Button
                    variant={tabs === "DEVICES" ? "terciary" : "secondary"}
                    type="button"
                    size="m"
                    isFull
                    onClick={() => setTabs("DEVICES")}
                  >
                    Dispositivos Vinculados
                  </Button>
                </StackRow>
                {isAdmin ? (
                  <StackRow>
                    <Button
                      variant={tabs === "ADMINXXX" ? "terciary" : "secondary"}
                      type="button"
                      size="m"
                      isFull
                      onClick={() => setTabs("ADMINXXX")}
                    >
                      Usuario Administrador
                    </Button>
                  </StackRow>
                ) : (
                  ""
                )}
              </Stack>
            </StackRow>
          </Stack>
        </Box>
        {tabs !== "" ? onSelectTab() : ""}
      </Box>
    </>
  );
};

export default MyProfile;
